import {memo} from 'react'

import RowGroup from '../Grid/RowGroup'

import styles from './Builds.css'

function BuildDetailsMargin() {
  return (
    <RowGroup key="margin">
      <div className={styles.oneLineMargin} />
    </RowGroup>
  )
}

export default memo(BuildDetailsMargin)
